<template>
  <v-card>
     <v-dialog v-model="dialogUpdateCar" persistent max-width="600px">
      <v-card class="text-center">
        <v-card-title>
             <v-combobox
            :items="itemsPlaces"
            label="Miejsce"
            item-text="place_key"
            item-value="place_key"
            :return-object="false"
            v-model="newplace.freeplaces"
          ></v-combobox>
        </v-card-title>
        <v-flex>
           <v-btn
            @click="dialogUpdateCar = false"
          text
          >
            {{$t("close")}}
          </v-btn>
          <v-btn
            color="red"
            text
            @click="updatecar()">
            {{$t("add")}}
          </v-btn>
       </v-flex>
      </v-card>
     </v-dialog>
    <v-toolbar  dense color="transparent">
      <v-toolbar-title><h4>Pojazdy</h4>
      </v-toolbar-title>
       <v-spacer></v-spacer>
       <v-btn @click="editon = !editon" icon>
        <v-icon>edit</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table no-data-text="Brak rekordów" :mobile-breakpoint='200'  hide-default-header  :custom-sort="func" :items-per-page=1000    :headers="headers" :items="itemsCars" hide-default-footer class="elevation-0">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.nr_rej }}</td>
          </template>
          <template v-slot:item.status="{item}">
            <div v-if="driveCheck(item.time_arrive,item.time_left)">
              <v-layout row>
        <v-flex><v-progress-linear class="mt-2" v-if="driveCheck(item.time_arrive,item.time_left)" :value="converttime(item.time_arrive,item.time_left)" height="5" color="blue"></v-progress-linear>  </v-flex>  
     <v-flex> {{item.to_key}}</v-flex>
    </v-layout></div>
    <v-layout row >
        <div v-if="!driveCheck(item.time_arrive,item.time_left) && item.cancel =='0' && (!carsTime(item.time_left,item.time) || item.freeplaces == '')">
        <v-icon color="green" v-if="item.to_key">keyboard_arrow_right</v-icon>{{item.to_key}}
        </div>
        <div class="" v-if="item.freeplaces && !driveCheck(item.time_arrive,item.time_left) && carsTime(item.time_left,item.time) ">  <v-icon color="blue" v-if="item.to_key">keyboard_arrow_right</v-icon>{{item.freeplaces}}</div>
      </v-layout>
      </template>
           
          <template v-slot:item.action="{ item }">
         <div v-if="editon" class="text-xs-right"><v-btn @click="openDialogUpdateCar(item)" text small icon ><v-icon>edit</v-icon></v-btn></div>

    </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>
<script>
const axios = require('axios');
import moment from 'moment'
export default {
   computed: {
    cars(){
      return this.store.state.cars;
    },
      datenow(){
      return this.store.state.dateNow
    },
    sortby(){
      return this.store.state.sortby
    },
    places(){
      return this.store.state.places;
    },
  },
  watch:{
      sortby: {
      handler: function(newValue,oldValue) {
      this.sort = newValue;
      },
      deep: true
    },
     cars: {
      handler: function(newValue) {
      this.itemsCars = newValue;

      },
      deep: true
    },
     places: {
      handler: function(newValue) {
      this.itemsPlaces = newValue;

      },
      deep: true
    },
     datenow: {
      handler: function(newValue) {
      this.dateNow = newValue;

      },
      deep: true,
    }
  },
  data() {
    return {
      headers: [
       // 
        { text: "Rejestracja", value: "nr_rej"},
        { text: "Status", value: "status" },
        { text: "action",value:"action" ,width:1 },
        
      ],
      itemsCars: this.store.state.cars || [],
      itemsPlaces: this.store.state.places || [],
      dialogAddCar:false,
      new_nr_rej:null,
      newplace:{},
      dialogUpdateCar:false,
      sort:this.store.state.sortby,
      editon:false,
      dateNow:this.store.state.dateNow,
      pagination:{'sortBy': 'to_key', 'descending': true, 'rowsPerPage': 100,},
    }
  },
  mounted(){
  },
  methods: {
     func(items, index, isDesc) {
      var data = this;
   function compare( a, b ) {
  if(b.freeplaces == "Kalisz" && data.carsTime(b.time_left,b.time) ){
    return -1
  }
  else return 0
}
return items.sort( compare );
  },
  carsTime(left,timeFreePlaces){
      let arrived = moment(left);
      let lefted = moment(timeFreePlaces);
      if(left < timeFreePlaces)return true 
        else return false
  },
    driveCheck(arrive,left){
      let now = moment().utc();
      let arrived = moment(arrive);
      let lefted = moment(left);
      if(now < arrived){return true}
        else{ return false }
    },

      driveCheckReverse(arrive,left){
      let now = moment().utc();
      let arrived = moment(arrive);
      let lefted = moment(left);
      if(now > arrived){return true}
        else{ return false }
    },

    converttime(arrived,lefted) {
    let now = moment().utc();
    let arrive = moment(arrived)
    let left =  moment(lefted)
     let  alltimedrive = left.diff(arrive,'hours');
     let realtimedrive = now.diff(left,'hours');
      if(Math.abs(Math.floor( realtimedrive / alltimedrive  * 100))>0 && Math.abs(Math.floor( realtimedrive / alltimedrive  * 100)) <= 100) return  Math.abs(Math.floor( realtimedrive / alltimedrive  * 100))
        else return 0
  },
    getCookie(cname){
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
 
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
    },
    refresh(){
  var data = this;
  var jwt = this.getCookie('jwt');
  axios.post('http://' + location.hostname + '/transportapp/php_file/validation_token.php', {
           jwt :jwt,
           data:data.dateNow,
           sortby:data.sort
    })
  .then(function (response) {
    if ( response.data.message == "access" ){
     data.store.state.routes = JSON.parse(response.data.routes);
      data.store.state.cars = JSON.parse(response.data.cars);
        data.store.state.allcars = JSON.parse(response.data.allcars);
          data.store.state.places = JSON.parse(response.data.places);
    } else if ( response.data.message == "denied" ) {
        data.$router.push('/auth/login');
    }
  })
 },
     addcar(){
     var data=this;
     var jwt = this.getCookie('jwt');
     axios.post('http://'+location.hostname+'/transportapp/php_file/addcar.php', {
           jwt :jwt,
           nr_rej: data.new_nr_rej
    })
     .then(function (response) {
      console.log(response)
      data.newRoute = {};
      data.dialogAddCar = false;
      data.refresh();
      data.new_nr_rej=null;
    
     })
     .catch(function (error) {
       console.log(error);
     });
},

  openDialogUpdateCar(value){
    this.newplace=value;
    this.dialogUpdateCar=true
  },
 updatecar(value){
     var data=this;
     var jwt = this.getCookie('jwt');
     axios.post('http://'+location.hostname+'/transportapp/php_file/updateCar.php', {
           jwt :jwt,
           id_car: data.newplace.id_car,
           place: data.newplace.freeplaces
    })
     .then(function (response) {
      data.refresh();
      data.dialogUpdateCar=false;
      data.newplace = {};
    
     })
     .catch(function (error) {
       console.log(error);
     });
    
},
  }
}
</script>
